import { __decorate } from "tslib";
import { Route } from '../core';
var DiscountMobileGlobal = /*@__PURE__*/ (function () {
    function DiscountMobileGlobal() {
    }
    DiscountMobileGlobal.get = function (response) {
        return response;
    };
    DiscountMobileGlobal = __decorate([
        Route('/vlux/subscriptions/discountmobile-global.json')
    ], DiscountMobileGlobal);
    return DiscountMobileGlobal;
}());
export { DiscountMobileGlobal };



//////////////////
// WEBPACK FOOTER
// ./app/bundles/enterprise-shop/src/api/endpoints/discountmobile-global.ts
// module id = null
// module chunks = 